import { Drawer } from 'antd';
import PropTypes from 'prop-types';
import useCheckMobileScreen from '../../app/hooks/useCheckMobileScreen';
import { IntlMessages } from '@/components';

const Sidebar = ({
  toggleSidebar,
  visible,
  children,
  title,
  placement = 'right',
  width = 500,
  destroyOnHidden = false,
  afterOpenChange,
}) => {
  const isMobile = useCheckMobileScreen(600);

  return (
    <Drawer
      title={title || <IntlMessages id="ui-general-filter" />}
      onClose={toggleSidebar}
      placement={placement}
      open={visible}
      size={isMobile ? 350 : width}
      destroyOnHidden={destroyOnHidden}
      afterOpenChange={afterOpenChange}
    >
      {children}
    </Drawer>
  );
};

Sidebar.propTypes = {
  title: PropTypes.any,
  width: PropTypes.number,
  toggleSidebar: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  destroyOnHidden: PropTypes.bool,
  afterOpenChange: PropTypes.func,
  placement: PropTypes.oneOf(['right', 'left', 'top', 'bottom']),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default Sidebar;
